import { t } from '../i18n.js';

/** De keuze van de periode boven de grafieken: knopjes op één rij, de gekozen ingedrukt. */
const LABEL = { 1: '24 uur', 7: '7 dagen', 30: '30 dagen', 90: '90 dagen', 180: '180 dagen', 365: '1 jaar' };

export default function Periodes({ keuzes, waarde, onKies }) {
  return (
    <span className="periodes" role="group" aria-label={t('Periode')}>
      {keuzes.map((d) => <button key={d} type="button" className="chip" aria-pressed={waarde === d} onClick={() => onKies(d)}>{t(LABEL[d])}</button>)}
    </span>
  );
}

/** Een duur in seconden, zo grof als past: minuten, uren of dagen. */
export function duurGrof(s) {
  if (s === null || s === undefined) return '—';
  if (s < 3600) return t('{n} min', { n: Math.max(1, Math.round(s / 60)) });
  if (s < 48 * 3600) return t('{n} uur', { n: Math.round(s / 360) / 10 });
  return t('{n} dagen', { n: Math.round(s / 86400) });
}
